// extracted by mini-css-extract-plugin
export default {"titulo":"EquiposTorneo_titulo__ca72v","listado":"EquiposTorneo_listado__tywTP","equipo":"EquiposTorneo_equipo__AdK8C"};